/**
 * Thin logger wrapper for the frontend.
 *
 * info/warn are no-ops in production to avoid leaking internal state.
 * error is always active so runtime exceptions remain visible to error tracking.
 */
const isDev = import.meta.env.DEV;

export const logger = {
  info: isDev ? console.log.bind(console) : () => {},
  warn: isDev ? console.warn.bind(console) : () => {},
  error: console.error.bind(console),
};
